import React from 'react';
import { Link } from 'react-router-dom';
import { usePublicConfig } from '../../hooks/usePublicConfig';
import { getDashboardPremiumOfferPath } from '../../config/constants';

/**
 * Modal affiché quand l'utilisateur tente d'accéder à une fonctionnalité premium sans y avoir droit.
 * Affiche les avantages, lien pour s'abonner et possibilité d'activer l'essai si éligible.
 */
function PremiumUpgradeModal({
  onClose,
  onActivateTrial,
  eligibleForTrial,
  title = 'Fonctionnalité Premium',
  featureName = 'cette fonctionnalité',
}) {
  const { config } = usePublicConfig();
  const paymentsEnabled = config.paymentsEnabled;

  return (
    <div className="premium-upgrade-modal-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className="premium-upgrade-modal" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        {paymentsEnabled ? (
          <>
            <p>
              <strong>{featureName}</strong> est réservée aux abonnés Premium (4,99 €/mois) ou à la période d&apos;essai gratuite.
            </p>
            <ul>
              <li>Accès à toutes les fonctionnalités premium</li>
              <li>Support prioritaire</li>
              <li>4,99 €/mois, annulable à tout moment</li>
            </ul>
            <div className="premium-upgrade-modal-actions">
              {eligibleForTrial && (
                <button type="button" className="premium-upgrade-modal-trial" onClick={onActivateTrial}>
                  Demander l&apos;essai gratuit (30 jours)
                </button>
              )}
              <Link
                to={getDashboardPremiumOfferPath()}
                className="premium-upgrade-modal-link"
                onClick={onClose}
              >
                Voir l&apos;offre Premium sur le tableau de bord
              </Link>
              <button type="button" className="premium-upgrade-modal-close" onClick={onClose}>
                Fermer
              </button>
            </div>
          </>
        ) : (
          <>
            <p>
              <strong>{featureName}</strong> est réservée aux abonnés Premium. Les paiements sont actuellement désactivés.
            </p>
            <div className="premium-upgrade-modal-actions">
              <button type="button" className="premium-upgrade-modal-close" onClick={onClose}>
                Fermer
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default PremiumUpgradeModal;
